/**
 * Utility function to merge class names (className utility)
 * Filters out falsy values and joins them with spaces
 * Supports objects with boolean values (clsx-style)
 *
 * @param classes - Class names to merge (falsy values are filtered out)
 *                  Can be strings, objects with boolean values, or arrays
 *
 * @returns Merged class name string
 *
 */
export function cn(
  ...classes: (
    | (Record<string, boolean | undefined> | string)[]
    | false
    | null
    | Record<string, boolean | undefined>
    | string
    | undefined
  )[]
): string {
  return classes
    .map((cls) => {
      if (typeof cls === "string") {
        return cls;
      }
      if (cls && typeof cls === "object" && !Array.isArray(cls)) {
        return Object.entries(cls)
          .filter(([, value]) => Boolean(value))
          .map(([key]) => key)
          .join(" ");
      }
      if (Array.isArray(cls)) {
        return cls
          .map((c) => {
            if (typeof c === "string") {
              return c;
            }
            if (typeof c === "object") {
              return Object.entries(c)
                .filter(([, value]) => Boolean(value))
                .map(([key]) => key)
                .join(" ");
            }
            return "";
          })
          .filter(Boolean)
          .join(" ");
      }
      return "";
    })
    .filter(Boolean)
    .join(" ");
}
